export default __webpack_public_path__ + "static/media/YAS0250.34I-29500_-17072_0.dfffcf7f.jpg";